import styled from 'styled-components';

export const Container = styled.div`
    background-color: white;
    width: auto;
    height: 100%;
    > .ant-list {
        height: 100%;
    }
}
`;

export const HeaderContainer = styled.div`
    display : flex;
    justify-content: space-between;
`;

export const Header = styled.div`
    height: 65px;
    > button {
        float: right;
    }
    > * {
        margin-bottom : 5px;
    }
}
`;
